/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState } from "react";
import { Loading } from "./AllReports";
import UserModal from "../../components/Modals/UserModal";

const UsersTable = ({ data, user, initialLoad, fetchData }) => {
  const [userObject, setUserObject] = useState({});

  return (
    <>
      <div className="contentTbl">
        <table className="overview" id="data-table">
          <thead>
            <tr>
              <th>Date Added</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Username</th>
              <th>Email</th>
              <th>Locations</th>
              <th></th>
            </tr>
          </thead>

          {initialLoad ? (
            <Loading />
          ) : data.length > 0 ? (
            <tbody>
              {data.map(({ groups, ...item }, index) => (
                <tr
                  key={item.id}
                  style={{ fontWeight: groups?.some((g) => g.name === "admin_group") ? "bolder" : "" }}
                >
                  <td>{new Date(item?.createdAt).toLocaleDateString()}</td>
                  <td>{item?.name}</td>
                  <td>{item?.family}</td>
                  <td>{item?.username}</td>
                  <td>{item?.email}</td>
                  <td>
                    {item?.locations
                      ?.map((l) => l.name)
                      .filter((i) => user?.locations.findIndex((l) => l.name === i) !== -1)
                      .join(", ")}
                  </td>
                  <td>
                    <div id={`view-btn-${index}`} className="show-options">
                      <a
                        href="#editUser"
                        className="btn btnTeal"
                        onClick={() => {
                          setUserObject(item);
                        }}
                      >
                        {user && user.groups.findIndex((g) => g.name === "admin_group") === -1
                          ? "View User"
                          : "Edit User"}
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          ) : null}
        </table>
        {data.length === 0 && !initialLoad ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 300,
              fontSize: 18,
            }}
          >
            No users
          </div>
        ) : null}
      </div>
      <UserModal
        title={"Edit User"}
        userObject={userObject}
        setUserObject={setUserObject}
        fetchData={fetchData}
      />
    </>
  );
};

export default UsersTable;
